export const SANCTION_TONE = (s) => {
  const t = (s || "").toLowerCase();
  if (t.includes("squalif")) return "danger";
  if (t.includes("drive-through")) return "danger";
  if (t.includes("10")) return "high";
  if (t.includes("5")) return "med";
  if (t.includes("avverti") || t.includes("warning") || t.includes("black/white")) return "warn";
  return "none";
};

export function SanctionBadge({ value, size = "md" }) {
  const tone = SANCTION_TONE(value);
  const map = {
    danger: "bg-red-500/10 border-red-500/50 text-red-400",
    high: "bg-orange-500/10 border-orange-500/50 text-orange-400",
    med: "bg-yellow-500/10 border-yellow-500/50 text-yellow-400",
    warn: "bg-zinc-700/30 border-zinc-600 text-zinc-200",
    none: "bg-emerald-500/10 border-emerald-500/40 text-emerald-400",
  };
  const sz = size === "lg" ? "text-base px-4 py-2" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-block border font-display font-bold uppercase tracking-wider ${map[tone]} ${sz}`}
      data-testid="sanction-badge"
    >
      {value || "—"}
    </span>
  );
}
